import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ISearchSuggestionResponse) {
    (function(ISearchRecommendation) {
        ISearchRecommendation.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ISearchSuggestionResponse.ISearchRecommendation || (ISearchSuggestionResponse.ISearchRecommendation = {}));
    (function(ISearchQueryWithFilters) {
        ISearchQueryWithFilters.build = function(partial) {
            return _object_spread({
                filters: [],
                filter_display_names: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ISearchSuggestionResponse.ISearchQueryWithFilters || (ISearchSuggestionResponse.ISearchQueryWithFilters = {}));
    ISearchSuggestionResponse.build = function(partial) {
        return _object_spread({
            suggested_search_queries: {},
            suggested_category_queries: {},
            suggested_brands: [],
            trending_searches: [],
            recently_viewed_products: [],
            top_search_results: [],
            recent_searches: [],
            suggested_search_queries_display_order: [],
            search_recommendations: [],
            suggested_apparel_categories: [],
            ordered_brands: [],
            recent_searches_with_filters: [],
            suggested_search_queries_with_filters: [],
            brands_you_may_know: [],
            suggested_navigations: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ISearchSuggestionResponse || (ISearchSuggestionResponse = {}));
export var ISearchSuggestionResponse;
